import {create} from "@/api/rest";

const publicEmailRequest = {
  connectToTeam: async (data) => await create('/public-email-request/connect-to-team', data),
};

export default publicEmailRequest;